import React, {lazy, Suspense} from 'react';

import type {DynamicWidgetProps} from './index';

const LazyWidget = lazy(() => import('components/ContentPagesComponents/DynamicWidget'));

export const DynamicWidget = (props: DynamicWidgetProps) => (
	<Suspense fallback={null}>
		<LazyWidget {...props} />
	</Suspense>
);
